import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { AlertService } from '@src/core/services';
import { LoyaltyRequestsService } from '@src/api';

import { RequestListItemType, ProductRequestType, ProductRequestChangesType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class LpProductRequestService {
  private readonly alertService = inject(AlertService);
  private readonly loyaltyRequestsService = inject(LoyaltyRequestsService);

  productRequests$ = new BehaviorSubject<RequestListItemType[] | null>(null);

  loadProductRequests(): Observable<RequestListItemType[]> {
    return this.loyaltyRequestsService.apiLoyaltyRequestsListGet().pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
      tap(requests => {
        this.productRequests$.next(requests);
      }),
    );
  }

  getProductRequestById(id: string): Observable<ProductRequestType> {
    return this.loyaltyRequestsService.apiLoyaltyRequestsRequestIdGet(id).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  createProductRequest(data: ProductRequestType) {
    return this.loyaltyRequestsService.apiLoyaltyRequestsAddPost(data).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  editProductRequest(data: ProductRequestChangesType) {
    return this.loyaltyRequestsService.apiLoyaltyRequestsEditPatch(data).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  deleteProductRequest(id: string) {
    return this.loyaltyRequestsService.apiLoyaltyRequestsDeleteRequestIdDelete(id).pipe(
      catchError(err => {
        this.alertService.error(err);
        return throwError(() => err);
      }),
    );
  }

  resetProductRequests() {
    this.productRequests$.next(null);
  }
}
